import React from 'react';
import { MdSave } from 'react-icons/md';
import { US_STATES } from '../../constants/locations';

function RepProfileEditForm({ editData, offices, submitting, onEditChange, onSave, onCancel }) {
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-xs font-medium text-gray-500 mb-1">First Name</label>
          <input
            type="text"
            name="first_name"
            value={editData.first_name}
            onChange={onEditChange}
            maxLength={100}
            className="w-full px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-primary"
            data-testid="edit-first-name"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-500 mb-1">Last Name</label>
          <input
            type="text"
            name="last_name"
            value={editData.last_name}
            onChange={onEditChange}
            maxLength={100}
            className="w-full px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-primary"
            data-testid="edit-last-name"
          />
        </div>
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-500 mb-1">Public Email</label>
        <input
          type="email"
          name="primary_email"
          value={editData.primary_email}
          onChange={onEditChange}
          className="w-full px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-primary"
          data-testid="edit-primary-email"
        />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-xs font-medium text-gray-500 mb-1">Office Level</label>
          <select
            name="office_level"
            value={editData.office_level}
            onChange={onEditChange}
            className="w-full px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-primary"
            data-testid="edit-office-level"
          >
            <option value="">Select level...</option>
            <option value="National">National</option>
            <option value="State">State</option>
            <option value="Local">Local</option>
          </select>
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-500 mb-1">Office</label>
          <select
            name="office_id"
            value={editData.office_id}
            onChange={onEditChange}
            disabled={!editData.office_level}
            className="w-full px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-primary disabled:bg-gray-100"
            data-testid="edit-office-select"
          >
            <option value="">Select office...</option>
            {editData.office_level && offices[editData.office_level]?.map((office) => (
              <option key={office.office_id} value={office.office_id}>
                {office.position_title}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className={`grid ${editData.office_level === 'Local' ? 'grid-cols-2' : 'grid-cols-1'} gap-3`}>
        <div>
          <label className="block text-xs font-medium text-gray-500 mb-1">Running State</label>
          <select
            name="running_state"
            value={editData.running_state}
            onChange={onEditChange}
            className="w-full px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-primary"
            data-testid="edit-running-state"
          >
            <option value="">Select state...</option>
            {US_STATES.map((state) => (
              <option key={state} value={state}>{state}</option>
            ))}
          </select>
        </div>
        {editData.office_level === 'Local' && (
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">City/County</label>
            <input
              type="text"
              name="running_city_county"
              value={editData.running_city_county}
              onChange={onEditChange}
              placeholder="e.g., Los Angeles"
              maxLength={100}
              className="w-full px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-primary"
              data-testid="edit-running-city"
            />
          </div>
        )}
      </div>
      <div className="flex gap-2 pt-1">
        <button
          onClick={onCancel}
          className="px-3 py-1.5 text-xs text-gray-600 hover:bg-gray-200 rounded-lg transition-colors"
          data-testid="cancel-edit-profile-btn"
        >
          Cancel
        </button>
        <button
          onClick={onSave}
          disabled={submitting}
          className="inline-flex items-center gap-1 px-3 py-1.5 text-xs bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors disabled:opacity-50"
          data-testid="save-edit-profile-btn"
        >
          <MdSave className="text-sm" />
          {submitting ? 'Saving...' : 'Save Changes'}
        </button>
      </div>
    </div>
  );
}

export default RepProfileEditForm;
